import { render, staticRenderFns } from "./WidgetOrange.vue?vue&type=template&id=e432b10c"
import script from "./WidgetOrange.vue?vue&type=script&lang=js"
export * from "./WidgetOrange.vue?vue&type=script&lang=js"
import style0 from "./WidgetOrange.vue?vue&type=style&index=0&id=e432b10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports